<template>
    <div class="page gc">
        <SideMenu />

        <div class="page-content g9">

            <h2 v-if="!isNew">Edit user</h2>
            <h2 v-else>Create user</h2>
            <form action="#" method="post" id="form">

                <FormBuilder :formData="formData" :formValue="editMember"></FormBuilder>

                <button class="left" type="button" v-if="!isNew" v-on:click="deleteMemberSoft" v-bind:class="{ 'loading': isDeleting }">Delete</button>                
                <button class="right" type="button" v-on:click="saveMemberAdminMode" v-bind:class="{ 'loading': isSaving }">Save</button>

            </form>

            <div v-if="!isNew">
                <h2 style="margin-bottom:19px;margin-top:19px;">User info</h2>
                <Accord title="User info">
                    <div class="grid-100w">
                        <table>
                            <tr>
                                <td><strong>Created:</strong> </td>
                                <td>{{editMember.createDateString}}</td>
                            </tr>
                            <tr>
                                <td><strong>Last login/validation:</strong> </td>
                                <td>{{editMember.lastSuccessfulValidationUtcString}}</td>
                            </tr>
                            <tr>
                                <td><strong>Total failed logins:</strong> </td>
                                <td>{{editMember.failedValidationAttempts}}</td>
                            </tr>
                            <tr>
                                <td><strong>Last failed validation date:</strong> </td>
                                <td>{{editMember.lastFailedValidationUtc}}</td>
                            </tr>
                            <tr>
                                <td style="vertical-align:top;"><strong>Password expire date</strong> </td>
                                <td style="vertical-align:top;">{{editMember.passwordExpireDateString}}<br/>
                                <i>User will automatically be asked to change password, or you can change it here to extend it for another year.</i>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Accord>
                <button class="left" style="margin-bottom:19px;" type="button" v-on:click="getMemberActivity" v-bind:class="{ 'loading': isLoadingActivity }">Load activity</button>
                <Accord title="User activity">
                    <table class="list">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Message</th>
                            </tr>
                        </thead>
                        <tbody>                                
                                <tr v-for="log in memberActivity">
                                    <td>{{log.logDateString}}</td>
                                    <td>{{log.message}}</td>
                                </tr>
                        </tbody>
                    </table>                                            
               </Accord>                                    
            </div>
        </div>
    </div>
</template>

<script>
    import API from "../../Api"
    import SideMenu from "../Components/SideMenuMembers.vue"
    import FormBuilder from "../Components/FormBuilder.vue"
    import Accord from "../Components/Accord.vue"
    import { mapState } from "vuex"

    export default {
        components: {
            SideMenu,
            FormBuilder,
            Accord
        },
        data: () => ({ 
            editMember: {},
            memberActivity: [],
            isNew: true,
            emailError: null,
            isDeleting: false,
            isSaving: false,
            isLoadingActivity: false,
            isNew:true,
            formData: [] //note we transferred form data to 'mounted' because we want to implement logic in the form data before sending to component.
        }),
       
        mounted()
        {            
            this.formData = [ 
                {
                title: "Edit user",
                    grid: "grid-50w",
                        forms: [
                            {
                                type: "text",
                                label: "First name",
                                placeholder: "John",
                                value: "firstName"
                            }, {
                                type: "text",
                                label: "Last name",
                                placeholder: "Appleseed",
                                value: "lastName"
                            }, {
                                type: "email",
                                label: "Email address",
                                placeholder: "johnappleseed@sponsor.com",
                                value: "email"
                            }, {
                                type: "text",
                                label: "Company",
                                placeholder: "Company name",
                                value: "companyName"
                            },
                            {
                                type: "text",
                                label: "New password",
                                placeholder: "Enter new password",
                                value: "newPassword"
                            }
                            ,
                            {
                                type: "text",
                                label: "Confirm new password",
                                placeholder: "Enter new password",
                                value: "confirmNewPassword"
                            }
                            ,
                            {
                                type: "checkbox",
                                label: "Locked",
                                value: "isLocked"
                            }
                            ,
                            {
                                type: "checkboxlist",
                                label: "Disable Login for",
                                value: "disableSignInFor",
                                preValues: [{
                                    label: "Okta Signin",
                                    value: "oktaSignIn",
                                }, {
                                    label: "Standard SignIn",
                                    value: "standardSignIn",
                                }]
                            }
                            ,
                            {
                                type: "radiolist",
                                label: "Role",
                                value: "memberRole",
                                preValues: this.getAllowedMemberRoles()
                            }
                        ]
                }];

             this.$store.dispatch("getEditMember", this.$route.params.id).then((res) => {
                  // this.isNew = res.data === null
                 //  debugger;
                 if (res != null) {
                     this.editMember = res;
                     this.isNew = false;
                     this.formData[0].title = "Edit user";
                 }
                 else {
                     this.editMember = {};
                     this.isNew = true;
                     this.formData[0].title = "Create user";
                 }                                   
                });                      
        },
        methods: {
            getAllowedMemberRoles() {
                var roles = [{
                                name: "User",
                                value: "1"
                            }, {
                                name: "Admin",
                                value: "3"
                            }];
                
                if (this.$store.state.member.isSuperAdmin) {
                    roles.push({ name : "SuperAdmin", value: "4"});
                }

                return roles;
            },
            deleteMemberSoft() {
                this.isDeleting = true;
                 this.$store.dispatch("deleteMemberSoft", this.$route.params.id).then((res) => {

                    // Do some fake loading to show user it's saved
                    setTimeout(() => {
                        this.isDeleting = false;
                    }, 600);

                     
                    this.$router.push("/member/list/")
                     

                }).catch((res) => {
                    this.isDeleting = false;
                })
            },
            saveMemberAdminMode() {
                var errors = this.validate();

                if (errors.length > 0) {
                    this.$store.state.error.data.type = "Please correct the following";
                    this.$store.state.error.data.message = errors;
                    this.$store.state.error.show = true;

                    return;
                }
                this.isSaving = true;
                 this.$store.dispatch("saveMemberAdminMode", this.editMember).then((res) => {

                    // Do some fake loading to show user it's saved
                    setTimeout(() => {
                        this.isSaving = false;
                    }, 600);
                     
                     if (this.isNew) {
                         this.$router.push("/member/edit/" + res.data.memberId)
                     }

                     this.editMember.newPassword = "";
                     this.editMember.confirmNewPassword = "";


                }).catch((res) => {
                    this.isSaving = false;
                })
            },
            getMemberActivity() {
                this.isLoadingActivity = true
                this.$store.dispatch("getMemberActivity", this.$route.params.id).then((res) => {
                  // this.isNew = res.data === null
                 //  debugger;
                 if (res != null && res.length > 0) {                     
                     this.memberActivity = res;                
                 }
                 else {
                     this.memberActivity = []
                     var fake = {logDateString:"No data", message:"No activity yet" };
                     this.memberActivity.push(fake);
                 }      
                 this.isLoadingActivity= false
                });       
            },
            validate() {
                var errors = [];
                if (this.isNew) {
                    if (this.editMember.newPassword == null || this.editMember.newPassword === "") {
                        errors.push("Password cannot be empty when creating a user");
                    }

                    if (this.editMember.confirmNewPassword == null || this.editMember.confirmNewPassword === "") {
                        errors.push("Confirmed password cannot be empty when creating a user");
                    }
                   
                }
                
                if (this.editMember.newPassword != this.editMember.confirmNewPassword) {
                    errors.push("New password and confirm new passwords must match");
                }
                
                if (this.editMember.firstName == null || this.editMember.firstName === "") {
                    errors.push("Firstname is empty");
                }

                if (this.editMember.lastName == null || this.editMember.lastName === "") {
                    errors.push("Lastname is empty");
                }

                if (this.editMember.email == null || this.editMember.email === "") {
                    errors.push("Email is empty");
                }

                  if (this.editMember.companyName == null || this.editMember.companyName === "") {
                    errors.push("Company is empty");
                }

                if (this.editMember.memberRole == null || this.editMember.memberRole === "") {
                    errors.push("You must choose a member role");
                }

                return errors;
            }
        }
    }
</script>
